import { EntityType } from '@frontend/common';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { TransactionClient } from '@frontend/transaction/api';
import { Transaction } from '@frontend/transaction/types';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { AdminObjectBadge } from '../../../components/admin-object-badge/admin-object-badge.component';

interface Props {
    filter: string;
}
export const TransactionSearch = (props: Props) => {
    const { currentAccount } = useAccountRepository();
    const [results, changeResults] = useState<Transaction[]>([]);

    useEffect(() => {
        if (props.filter !== '')
            TransactionClient.fetchTransactions({ account_id: currentAccount, search: props.filter }).then((result) => {
                changeResults(result.results);
            });
    }, [props.filter, currentAccount]);

    if (results.length === 0) return null;
    return (
        <div className='mb-3 p-1'>
            <span className='border-border-default flex flex-row items-center justify-between border-b-1 pb-1'>
                <div className='ml-1 font-bold'>{CommonMessage.OBJECTS.TRANSACTION.PLURAL}</div>
                <Link
                    className='mx-1 text-sm font-medium underline'
                    to='/transactions'>
                    {CommonMessage.BUTTONS.SHOW_ALL}
                </Link>
            </span>
            <div className='flex flex-col'>
                {results.map((result) => (
                    <AdminObjectBadge
                        entityType={EntityType.TRANSACTION}
                        id={result.id}
                    />
                ))}
            </div>
        </div>
    );
};
